import { stripHtml, type CbObj } from "string-strip-html";

export default function Label({
  className = "",
  text,
}: {
  className?: string;
  text: string;
}) {
  if (!text) return null;

  function filterTags({ tag, deleteFrom, deleteTo, insert, rangesArr }: CbObj) {
    if (
      tag.name == "p" ||
      tag.name == "ul" ||
      tag.name == "li" ||
      tag.name == "b" ||
      tag.name == "strong" ||
      tag.name == "h3" ||
      tag.name == "desclist" ||
      tag.name == "a" ||
      tag.name == "div" ||
      tag.name == "notice" ||
      tag.name == "info" ||
      tag.name == "center" ||
      tag.name == "space"
    )
      return true;
    if (deleteFrom != null && deleteTo != null) {
      rangesArr.push(deleteFrom, deleteTo, insert);
    }
  }

  function massageHtml(
    element: ChildNode,
    subNode?: boolean,
  ): string {
    if (!(element instanceof Element)) {
      return element.textContent ?? "";
    }

    let result = "";

    if (element.tagName == "INFO") {
      result += `<div class="inline-flex bg-[#5f8cf1] text-white my-2 text-base text-gray-800 border-[2px] border-[#5f8cf1] rounded-xl flex gap-x-4 items-center py-1.5 pl-2 pr-8">`;
      result += `              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white"
                      class="h-8 w-8 flex-none" aria-hidden="true">
  <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
</svg>

      <div class="${
        element.childNodes[0] instanceof Element && element.childNodes[0].tagName == "P" ? "-mt-1" : ""
      } py-1 flex-initial">`;
      if (element.childNodes.length > 0) {
        element.childNodes.forEach(
          (child: ChildNode) => (result += massageHtml(child, true)),
        );
      } else {
        result += element.innerHTML;
      }
      result += "</div></div>";
      result;
    } else if (element.tagName == "NOTICE") {
      result += `<div class="my-2 font-bold text-base text-[--primary-color-darker] flex gap-x-2 items-center">`;
      result += `  <svg
    class="scale-x-[-1] h-6 w-6 mr-0.5 self-start mt-0.5"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    aria-hidden="true"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path data-name="layer2" fill=${getComputedStyle(
      document.body,
    ).getPropertyValue(
      "--primary-color",
    )} d="M2.86 8.101v40h18v11.024l12-11.024h30v-40h-60z"></path>
    <path
      data-name="layer1"
      d="M34.86 32.125a2.025 2.025 0 0 1-2 2 2.227 2.227 0 0 1-2-2l-1-15a2.779 2.779 0 0 1 3-3 2.652 2.652 0 0 1 3 3z"
      fill="white"
    ></path>
    <circle data-name="layer1" cx="32.86" cy="40.125" r="2" fill="white"></circle>
  </svg><div class="${element.childNodes[0] instanceof Element && element.childNodes[0].tagName == "P" ? "-mt-1" : ""}">`;
      if (element.childNodes.length > 0) {
        element.childNodes.forEach(
          (child: ChildNode) => (result += massageHtml(child, true)),
        );
      } else {
        result += element.innerHTML;
      }
      result += "</div></div>";
      result;
    } else if (element.tagName == "DESCLIST") {
      result += `<div class="my-2 border-t border-gray-100"><dl class="grid grid-cols-1 sm:grid-cols-2 divide-y divide-gray-100">`;

      element.innerHTML.split("|").filter(Boolean).forEach((item) => {
        const [label, value] = item.split("^");
        result += `<div class="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3 sm:col-span-1">`;
        result += `<dt class="text-base font-medium leading-6 text-gray-900">${label}</dt>`;
        result += `<dd class="mt-1 text-base leading-6 text-gray-700 sm:col-span-2 sm:mt-0">${value ?? ""}</dd>`;
        result += `</div>`;
      });

      result += `</dl></div>`;
    } else if (element.tagName == "A") {
      result += `<a target='_blank'
            rel='noopener noreferrer'
            class="self-start relative inline-flex items-center text-sm font-bold  focus:z-10 px-1"
            style="color: var(--primary-color)"
            href='${element.getAttribute("href")}'>`;
      if (element.childNodes.length > 0) {
        element.childNodes.forEach(
          (child: ChildNode) => (result += massageHtml(child, true)),
        );
      } else {
        result += element.innerHTML;
      }

      result += `<span class="sr-only">(opens in new tab)</span><span class="ml-1.5">          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
            aria-hidden="true"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            class="w-3 h-3"
          >
            <path
              data-name="layer2"
              fill="none"
              stroke="currentColor"
              stroke-miterlimit="10"
              stroke-width="6"
              d="M30 62h32V2H2v32"
              stroke-linejoin="round"
              stroke-linecap="round"
            ></path>
            <path
              data-name="layer1"
              fill="none"
              stroke="currentColor"
              stroke-miterlimit="10"
              stroke-width="10"
              d="M26 56V38H8m18 0L2 62"
              stroke-linejoin="round"
              stroke-linecap="round"
            ></path>
          </svg></span>`;
      result += "</a>";
    } else if (element.tagName == "B" || element.tagName == "STRONG") {
      result += `<b>`;
      if (element.childNodes.length > 0) {
        element.childNodes.forEach(
          (child: ChildNode) => (result += massageHtml(child, true)),
        );
      } else {
        result += element.innerHTML;
      }
      result += "</b>";
    } else if (element.tagName == "H3") {
      result += `<h3 class="text-2xl font-semibold leading-9 tracking-tight text-[--primary-color]">`;
      if (element.childNodes.length > 0) {
        element.childNodes.forEach(
          (child: ChildNode) => (result += massageHtml(child, true)),
        );
      } else {
        result += element.innerHTML;
      }
      result += "</h3>";
    } else if (element.tagName == "SPACE") {
      result += `<div class="h-3"></div>`;
    } else if (element.tagName == "CENTER") {
      result += `<div class="text-center">`;
      if (element.childNodes.length > 0) {
        element.childNodes.forEach(
          (child: ChildNode) => (result += massageHtml(child, true)),
        );
      } else {
        result += element.innerHTML;
      }
      result += "</div>";
    } else if (element.tagName == "P") {
      result += `<p class="mt-1 mb-1">`;
      if (element.childNodes.length > 0) {
        element.childNodes.forEach(
          (child: ChildNode) => (result += massageHtml(child, true)),
        );
      } else {
        result += element.innerHTML;
      }
      result += "</p>";
    } else if (element.tagName == "UL") {
      result += `<ul class="space-y-1 text-gray-600 list-disc list-outside pl-12">`;
      if (element.childNodes.length > 0) {
        element.childNodes.forEach(
          (child: ChildNode) => (result += massageHtml(child, true)),
        );
      } else {
        result += element.innerHTML;
      }
      result += `</ul>`;
    } else if (element.tagName == "LI") {
      result += `<li>`;
      if (element.childNodes.length > 0) {
        element.childNodes.forEach(
          (child: ChildNode) => (result += massageHtml(child, true)),
        );
      } else {
        result += element.innerHTML;
      }
      result += `</li>`;
    } else if (element.tagName == "DIV") {
      result += `<div>`;
      if (element.childNodes.length > 0) {
        element.childNodes.forEach(
          (child: ChildNode) => (result += massageHtml(child, true)),
        );
      } else {
        result += element.innerHTML;
      }
      result += `</div>`;
    } else {
      result += element.textContent ?? "";
    }

    return result;
  }

  const parsed = new DOMParser().parseFromString(
    stripHtml(`<div>${text}</div>`, { cb: filterTags }).result,
    "text/html",
  );

  let filteredResult = "";
  if (parsed.body.children.length == 0) {
    filteredResult = parsed.body.textContent ?? "";
  } else {
    Array.from(parsed.body.children).forEach((element) => {
      filteredResult += massageHtml(element);
    });
  }

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: filteredResult }}
    />
  );
}
